import React from "react"
import { ServerResourceIcon, hasIcon } from "./server_resource_icon"

export interface IconOrEmojiProps {
  /** Server icon identifier. Takes priority when it maps to a known icon. */
  icon?: string | null
  /** Emoji shown as the fallback when there's no (valid) icon. */
  emoji?: string | null
  size?: number
  className?: string
}

/**
 * Renders a section/resource glyph: the server icon when one is set (and known), otherwise the emoji,
 * otherwise nothing. Centralizes the "icon, then emoji" fallback so the tree, the daily-scene menu, and
 * anywhere else showing a section adornment stay consistent.
 */
export const IconOrEmoji: React.FC<IconOrEmojiProps> = ({
  icon,
  emoji,
  size = 16,
  className,
}) => {
  if (icon && hasIcon(icon)) {
    return <ServerResourceIcon icon={icon} size={size} className={className} />
  }
  if (emoji) {
    return (
      <span
        aria-hidden
        className={className}
        style={{ fontSize: size, lineHeight: 1 }}
      >
        {emoji}
      </span>
    )
  }
  return null
}

export default IconOrEmoji
